import React, { FC, useEffect, useState } from "react";
import classNames from "classnames";
import _isEmpty from "lodash/isEmpty";
import { connect } from "react-redux";
import PAGES from "../../../../../../constants/pages";
import { RootState } from "../../../../../../models";
import { AccountMember } from "../../../../../../models/state";
import { getSubscriptionGroupMembers } from "../../../state/selectors/accountSelectors";
import TEXT from "../../../text-consts";
import RegisteredMemberCard from "../../molecules/RegisteredMemberCard/RegisteredMemberCard";
import "./RegisteredMemberCardList.less";

interface StateProps {
    members: AccountMember[];
}

interface RegisteredMemberCardListProps extends StateProps {
    noMargin?: boolean;
    showList?: boolean;
}
const RegisteredMemberCardList: FC<RegisteredMemberCardListProps> = ({ members, noMargin, showList = false }) => {
    const [shouldShowList, setShouldShowList] = useState(false);

    useEffect(() => {
        setShouldShowList(true);
    }, []);

    if (!shouldShowList) {
        return null;
    }

    const legalMember = members.find((member) => member.isLegal);
    const nonLegalMembers = members.filter((member) => !member.isLegal);

    if (_isEmpty(legalMember)) {
        return null;
    }

    return (
        <div
            data-di-mask
            className={classNames("registered-member-card-list", {
                "registered-member-card-list__no-margin": noMargin,
            })}
        >
            <RegisteredMemberCard
                key={`registered-member-${legalMember.number}`}
                title={TEXT.MULTIPLE_SUBSCRIPTIONS.REGISTERED_MEMBER_TITLE({
                    isExisting: legalMember.isExisting,
                    isLegal: legalMember.isLegal,
                    isB2BFamilyOffer: legalMember.isB2BFamilyOffer,
                })}
                name={legalMember.name}
                isExisting={legalMember.isExisting}
                isInProcess={legalMember.isInProcess}
            />
            {showList && (
                <div className="registered-member-card-list__indented-members">
                    {nonLegalMembers.map(
                        ({ id: memberId, name, number, isLegal, isExisting, isInProcess, subscriptionName }) => {
                            let onEdit;

                            if (!isLegal && !isExisting && !isInProcess) {
                                onEdit = () => {
                                    window.location.assign(`${PAGES.CHECKOUT.ADD_MEMBER.URL}#edit=${memberId}`);
                                };
                            }
                            return (
                                <div
                                    className="registered-member-card-list__indented-members__item"
                                    key={`registered-member-${number}`}
                                >
                                    <RegisteredMemberCard
                                        title={TEXT.MULTIPLE_SUBSCRIPTIONS.REGISTERED_MEMBER_TITLE({
                                            isExisting,
                                            isLegal,
                                            subscriptionName,
                                        })}
                                        name={name}
                                        onEdit={onEdit}
                                        isExisting={isExisting}
                                        isInProcess={isInProcess}
                                    />
                                </div>
                            );
                        },
                    )}
                </div>
            )}
        </div>
    );
};

const mapStateToProps = (state: RootState): StateProps => ({
    members: getSubscriptionGroupMembers(state),
});

export default connect(mapStateToProps, {})(RegisteredMemberCardList);
